// src/utils/distance.js
import { Loader } from "@googlemaps/js-api-loader";
import { GOOGLE_MAPS_SCRIPT_ID, GOOGLE_MAPS_LIBRARIES } from "../config/googleMaps";

let loader;
/** Load the Maps JS API (same project/key as places.js) */
async function ensureMaps() {
  if (!loader) {
    loader = new Loader({
      id: GOOGLE_MAPS_SCRIPT_ID,
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY,
      version: "weekly",
      libraries: GOOGLE_MAPS_LIBRARIES,
    });
  }
  await loader.load();
  return window.google;
}

/**
 * Get driving distance (miles) between two address strings.
 * Returns a number (miles, rounded to 1 decimal) or null if it can’t route.
 */
export async function getDrivingMiles(origin, destination) {
  if (!origin || !destination) return null;

  const google = await ensureMaps();
  const svc = new google.maps.DirectionsService();

  const res = await svc.route({
    origin,
    destination,
    travelMode: google.maps.TravelMode.DRIVING,
  });

  const leg = res?.routes?.[0]?.legs?.[0];
  if (!leg?.distance?.value) return null;

  // meters -> miles
  const miles = leg.distance.value / 1609.344;
  // round to 1 decimal so totals feel stable (you can change)
  return Math.round(miles * 10) / 10;
}
